import Ayuda from '../ui/Ayuda';
import { textoDeLicencias } from './licenciaDeTerminal';

/* =====================================================================
   Las terminales compradas · el aviso verde de Terminales (DISEÑO-F1b §7)
   =====================================================================
   Solo con al menos una comprada: «Tienes N terminal(es) lista(s) para
   conectar», sus series, la reserva pendiente si la hay, y una línea
   neutra cuando el resto del módulo sigue en consulta. Sin precios.
   Sin compradas no pinta nada: la pantalla de siempre.
   ===================================================================== */
export default function LicenciasDeTerminal({ licencia }) {
  const t = textoDeLicencias(licencia);
  if (!t) return null;
  return (
    <section role="status" data-aviso-compradas="" className="space-y-1 rounded-xl border border-green-200 bg-green-50 p-3 text-sm text-green-900">
      <strong className="block break-words">{t.titulo}</strong>
      {t.lineas.map((l) => <p key={l} className="break-words">{l}</p>)}
      <Ayuda id="terminal.licencia.compradas" />
      <Ayuda id="terminal.licencia.ficha" />
    </section>
  );
}
